import { createSelector } from '@ngrx/store';
import { selectProductTypesState } from '../reducers';
import * as fromCxProductType from '../reducers/cx-product-type.reducer';
import { CxProductTypeEntity } from '../reducers/cx-product-type.reducer';

export const selectCxProductTypes = createSelector(selectProductTypesState, fromCxProductType.selectAll);
export const selectCxProductTypeIds = createSelector(selectProductTypesState, fromCxProductType.selectIds);
export const selectCxProductTypeEntities = createSelector(selectProductTypesState, fromCxProductType.selectEntities);
export const selectCxProductTypeTotal = createSelector(selectProductTypesState, fromCxProductType.selectTotal);
export const selectCxProductTypeById = () =>
  createSelector(selectCxProductTypeEntities, (cxProductTypeEntities, { id }) => cxProductTypeEntities[id]);

export const selectCxProductTypesById = () =>
  createSelector(
    selectCxProductTypeEntities,
    (cxProductTypeEntities, { ids }) =>
      ids.map((id) => cxProductTypeEntities[id]).filter(Boolean) as CxProductTypeEntity[],
  );
export const selectActiveCxProductTypeId = createSelector(
  selectProductTypesState,
  fromCxProductType.selectActiveEntityId,
);
export const selectActiveCxProductType = createSelector(
  selectCxProductTypeEntities,
  selectActiveCxProductTypeId,
  (cxProductTypeEntities, id) => id && cxProductTypeEntities[id],
);
